document.addEventListener('DOMContentLoaded', () => {
  // define elements
  const root = document.querySelector(':root');
  const body = document.body;
  const numbers = document.getElementById('numbers');
  const secondHand = document.getElementById('second-hand');
  const minuteHand = document.getElementById('minute-hand');
  const hourHand = document.getElementById('hour-hand');
  const darkModeToggle = document.getElementById('btn-dark-mode');

  // define flags
  let darkMode = false;

  // init fn
  const init = () => {
    addNumbers();
    addShadows();
    addDarkModeToggle();
    setCurrentTime();
  };

  // add the numbers
  const addNumbers = () => {
    for (let n = 1; n <= 12; n++) {
      const node = document.createElement('span');
      node.setAttribute('data-number', n);
      numbers.appendChild(node);
    }
  };

  // add the shadows
  // would be nice to just add filter:drop-shadow to the existing hands
  // but unfortunately keyframes don't interpolate offset values properly
  // so the shadow snaps to the nearest pixel, which is distracting
  const addShadows = () => {
    [secondHand, minuteHand, hourHand].forEach(hand => {
      const shadow = document.createElement('span');
      shadow.classList.add('shadow');
      hand.appendChild(shadow);
    });
  };

  // toggle dark mode
  const addDarkModeToggle = () => {
    darkModeToggle.addEventListener('click', () => {
      body.classList.toggle('dark-mode');
      darkMode = !darkMode;
      darkModeToggle.innerHTML = darkMode ? 'lights on' : 'lights out';
    });
  };

  // set current time
  const setCurrentTime = () => {
    const now = new Date();

    // set current time values for each hand
    const elapsedSeconds = now.getSeconds();
    root.style.setProperty('--animation-delay-second-hand', `-${elapsedSeconds}s`);

    const elapsedMinutes = now.getMinutes() + (elapsedSeconds / 60);
    root.style.setProperty('--animation-delay-minute-hand', `-${Math.round(elapsedMinutes * 60)}s`);

    const elapsedHours = (now.getHours() % 12) + (elapsedMinutes / 60);
    root.style.setProperty('--animation-delay-hour-hand', `-${Math.round(elapsedHours * 60 * 60)}s`);

    // un-pause the animations
    root.style.setProperty('--animation-play-state', 'unset');
  };

  // init
  init();
});
